import Axios from 'axios';
import ErrorHandler from './error';

const httpClient = Axios.create();

let apiUrl = 'https://api.hachigroup.id/';

const HttpPost = async (url, data, tempToken) => {
  const accessToken = localStorage.getItem('accessToken');

  return httpClient.post(apiUrl + url, data, {
    headers: {
      Authorization: accessToken ? `Bearer ${accessToken}` : tempToken ? `Bearer ${tempToken}` : null,
    },
  })
    .then((res) => {
      return res.data.data;
    })
    .catch((error) => {
      ErrorHandler(error);
      throw error;
    });
};

const HttpGet = async (url, tempToken) => {
  const accessToken = localStorage.getItem('accessToken');

  return httpClient
    .get(apiUrl + url, {
      headers: {
        Authorization: accessToken ? `Bearer ${accessToken}` : tempToken ? `Bearer ${tempToken}` : null,
      },
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((error) => {
      console.log(error);
      ErrorHandler(error);
      throw error;
    });
};


const HttpGets = async (url, tempToken) => {
  const accessToken = localStorage.getItem('accessToken');

  Axios.get('https://9d34-114-10-43-32.ngrok-free.app/data/outlets/15/customer-types', {
   headers: {
    Authorization: `Bearer ${accessToken}`,
    'ngrok-skip-browser-warning': 'true'
  }

})
.then(response => {
  console.log(response.data);
  return response.data
})
.catch(error => {
  return error;
  console.error(error);
});

};

const HttpGetWithoutToken = async (url) => {
  return httpClient
    .get(apiUrl + url)
    .then((res) => {
      return res.data.data;
    })
    .catch((error) => {
      ErrorHandler(error);
      throw error;
    });
};

export { HttpPost, HttpGet, HttpGets, HttpGetWithoutToken };
